
import React, { useState } from 'react';
import CustomButton from '../../../components/common/CustomButton';
import HeaderWrapper from '../../../components/common/HeaderWrapper';
import { SearchIcon } from '../../../components/common/IconComponents';
import Pagination from '../../../components/common/Pagination';
import AddMemberModal from './AddMemberModal';
import { all } from "../../../utils/Data";

// role badge
const getRoleStyle = (role) => {
  if (role.toLowerCase() === 'admin') {
    return 'inline-flex items-center px-1 md:px-2 py-0.5 rounded-md border border-1 border-admin-border bg-th-bg text-enabled-btn text-[10px] md:text-xs font-medium';
  } else if (role.toLowerCase() === 'analyst') {
    return 'inline-flex items-center px-1 md:px-2 py-0.5 rounded-md border border-1 border-analyst-border bg-analyst-bg text-analyst-text text-[10px] md:text-xs font-medium';
  } else {
    return 'inline-flex items-center px-1 md:px-2 py-0.5 rounded-md border border-1 border-analyst-border bg-analyst-bg text-analyst-text text-[10px] md:text-xs font-medium';
  }
};

const Teams = () => {
  // modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // tab
  const [activeTab, setActiveTab] = useState('all');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // pagination
  const [activePage, setActivePage] = useState(1);
  const itemsPerPage = 12;
  const totalItems = activeTab === 'all' ? all.length : activeTab === 'admin' ? all.filter((team) => team.role.toLowerCase() === 'admin').length : all.filter((team) => team.role.toLowerCase() === 'analyst').length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setActivePage(pageNumber);
    } else if (pageNumber < 1) {
      setActivePage(1);
    } else if (pageNumber > totalPages) {
      setActivePage(1);
    }
  };

  // search
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (event) => {
    const inputText = event.target.value;
    const sanitizedText = inputText.replace(/\s/g, ''); // Remove spaces from the input text
    setSearchQuery(sanitizedText);
  };

  // Filtered data based on search query and active tab
  let filteredData;
  if (activeTab === 'all') {
    filteredData = all.filter((team) =>
      team.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  } else if (activeTab === 'admin') {
    filteredData = all.filter((team) =>
      team.role.toLowerCase() === 'admin' &&
      team.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  } else if (activeTab === 'analyst') {
    filteredData = all.filter((team) =>
      team.role.toLowerCase() === 'analyst' &&
      team.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  const allCount = all.length;
  const adminCount = all.filter((team) => team.role.toLowerCase() === 'admin').length;
  const analystCount = all.filter((team) => team.role.toLowerCase() === 'analyst').length;

  return (
    <div className="">
      <HeaderWrapper>
        <header className="flex flex-wrap w-full items-center justify-between -mt-1">
          <div className="flex basis-2/3 items-center justify-between md:-ms-4">
            <div className="w-1/6 me-4 md:me-0">
              <h2 className="text-lg md:text-xl font-medium">Teams</h2>
            </div>

            <div className="relative flex-initial w-5/6 items-center justify-start">
              <input
                type="text"
                className="w-5/6 lg:py-2 pl-11 pr-4 text-xs md:text-sm lg:text-base font-normal bg-gray-50 border border-gray-50 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearch}
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
                <SearchIcon className="w-3 h-5" />
              </div>
            </div>
          </div>

          <div className="basis-1/3 flex flex-initial justify-end">
            <CustomButton onClick={openModal}>Add team member</CustomButton>
            <AddMemberModal isOpen={isModalOpen} onClose={closeModal} />
          </div>
        </header>
      </HeaderWrapper>

      <div className="px-2 md:px-8">
        {/* Tab */}
        <div className="">
          <ul className="flex flex-wrap mb-px text-center" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
            <li className="mr-2" role="presentation">
              <button className={`inline-block p-2 text-sm lg:text-base font-normal rounded-t-lg ${activeTab === 'all' ? 'border-b-2 border-blue-500' : ''}`} id="all-tab" data-tabs-target="#all" type="button" role="tab" aria-controls="all" aria-selected={activeTab === 'all'} onClick={() => handleTabClick('all')}>All ({allCount})</button>
            </li>
            <li className="mr-2" role="presentation">
              <button className={`inline-block p-2 text-sm lg:text-base rounded-t-lg ${activeTab === 'admin' ? 'border-b-2 border-blue-500' : ''}`} id="admin-tab" data-tabs-target="#admin" type="button" role="tab" aria-controls="admin" aria-selected={activeTab === 'admin'} onClick={() => handleTabClick('admin')}>Admin ({adminCount})</button>
            </li>
            <li className="mr-2" role="presentation">
              <button className={`inline-block p-2 text-sm lg:text-base rounded-t-lg ${activeTab === 'analyst' ? 'border-b-2 border-blue-500' : ''}`} id="analyst-tab" data-tabs-target="#analyst" type="button" role="tab" aria-controls="analyst" aria-selected={activeTab === 'analyst'} onClick={() => handleTabClick('analyst')}>Analyst ({analystCount})</button>
            </li>
          </ul>
        </div>

        {/* Tab content */}
        <div id="myTabContent" className='hidden'>
          <div className={`p-4 ${activeTab === 'all' ? 'block' : 'hidden'}`} id="all" role="tabpanel" aria-labelledby="all-tab"></div>
          <div className={`p-4 ${activeTab === 'admin' ? 'block' : 'hidden'}`} id="admin" role="tabpanel" aria-labelledby="admin-tab"></div>
          <div className={`p-4 ${activeTab === 'analyst' ? 'block' : 'hidden'}`} id="analyst" role="tabpanel" aria-labelledby="analyst-tab"></div>
        </div>

        {/* Table */}
        <div className="w-full mt-4">
          <table className="w-full table-fixed ">
            <thead>
              <tr>
                <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal bg-th-bg border-none">NO</th>
                <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal bg-th-bg border-none">User ID</th>
                <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal bg-th-bg border-none">Name</th>
                <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal bg-th-bg border-none">Role</th>
                <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal bg-th-bg border-none">Last seen</th>
              </tr>
            </thead>
            <tbody>
              {filteredData
                .slice((activePage - 1) * itemsPerPage, activePage * itemsPerPage)
                .map((team, index) => (
                  <tr key={team.id}>
                    <td className="p-1 md:p-2 text-start text-[10px] md:text-sm font-normal text-teams-body-text border-b">{(activePage - 1) * itemsPerPage + index + 1}</td>
                    <td className="p-1 md:p-2 text-start text-[10px] md:text-sm font-normal text-teams-body-text border-b">{team.userId}</td>
                    <td className="p-1 md:p-2 text-start text-[10px] md:text-sm font-normal text-teams-body-text border-b">{team.name}</td>
                    <td className="p-1 md:p-2 text-start border-b">
                      <span className={getRoleStyle(team.role)}>
                        {team.role.toLowerCase() === 'user' ? 'Analyst' : team.role}
                      </span>
                    </td>
                    <td className="p-1 md:p-2 text-start text-[10px] md:text-sm  font-normal text-teams-body-text border-b">{team.lastSeen}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        
        {/* Pagination */}
        <Pagination
          totalPages={totalPages}
          activePage={activePage}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
}

export default Teams;



// INITIAL CODE WITH EXTERNAL ALL, ADMIN & ANALYST TAB COMPONENTS. ENDED UP NOT USING IT, LEFT FOR REFERENCE PURPOSES
// import React, { useState } from 'react';
// import CustomButton from '../../../components/common/CustomButton';
// import HeaderWrapper from '../../../components/common/HeaderWrapper';
// import { SearchIcon } from '../../../components/common/IconComponents';
// import AllTab from './AllTab';
// import AdminTab from './AdminTab';
// import AnalystTab from './Analyst';
// import Pagination from '../../../components/common/Pagination';
// import AddMemberModal from './AddMemberModal';

// const Teams = () => {
//   // modal
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const openModal = () => {
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   // pagination
//   const [activePage, setActivePage] = useState(1);
//   const totalPages = 21; // Total number of pages

//   const handlePageChange = (pageNumber) => {
//     setActivePage(pageNumber);
//     // Handle fetching data or updating the page content based on the new page number
//   };

//   // tab
//   const [activeTab, setActiveTab] = useState('all');

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   // search
//   const [searchQuery, setSearchQuery] = useState('');

//   const handleSearch = (event) => {
//     const inputText = event.target.value;
//     const sanitizedText = inputText.replace(/\s/g, ''); // Remove spaces from the input text
//     setSearchQuery(sanitizedText);
//   };

//   return (
//     <div className="">
//       <HeaderWrapper>
//         <header className="flex flex-wrap w-full items-center justify-between -mt-1">
//           <div className="flex basis-2/3 items-center justify-between">
//             <div className="w-1/6">
//               <h2 className="text-xl font-medium">Teams</h2>
//             </div>

//             <div className="relative flex-initial w-5/6 items-center justify-start mt-2 sm:mt-0">
//               <input
//                 type="text"
//                 className="w-5/6 lg:py-2 pl-11 pr-4 text-xs md:text-sm lg:text-base font-normal bg-gray-50 border border-gray-50 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 placeholder="Search"
//                 value={searchQuery}
//                 onChange={handleSearch}
//               />
//               <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
//                 <SearchIcon className="w-3 h-5" />
//               </div>
//             </div>
//           </div>

//           <div className="basis-1/3 flex flex-initial justify-end">
//             <CustomButton onClick={openModal}>Add team member</CustomButton>
//             <AddMemberModal isOpen={isModalOpen} onClose={closeModal} />
//           </div>
//         </header>
//       </HeaderWrapper>

//       <div className="px-8">
//         {/* Tab */}
//         <div className="">
//           <ul className="flex flex-wrap mb-px ps-4 text-center" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
//             <li className="mr-2" role="presentation">
//               <button className={`inline-block p-2 text-sm lg:text-base font-normal rounded-t-lg ${activeTab === 'all' ? 'border-b-2 border-blue-500' : ''}`} id="all-tab" data-tabs-target="#all" type="button" role="tab" aria-controls="all" aria-selected={activeTab === 'all'} onClick={() => handleTabClick('all')}>All (200)</button>
//             </li>
//             <li className="mr-2" role="presentation">
//               <button className={`inline-block p-2 text-sm lg:text-base rounded-t-lg ${activeTab === 'admin' ? 'border-b-2 border-blue-500' : ''}`} id="admin-tab" data-tabs-target="#admin" type="button" role="tab" aria-controls="admin" aria-selected={activeTab === 'admin'} onClick={() => handleTabClick('admin')}>Admin (20)</button>
//             </li>
//             <li className="mr-2" role="presentation">
//               <button className={`inline-block p-2 text-sm lg:text-base rounded-t-lg ${activeTab === 'analyst' ? 'border-b-2 border-blue-500' : ''}`} id="analyst-tab" data-tabs-target="#analyst" type="button" role="tab" aria-controls="analyst" aria-selected={activeTab === 'analyst'} onClick={() => handleTabClick('analyst')}>Analyst (180)</button>
//             </li>
//           </ul>
//         </div>

//         {/* Tab content */}
//         <div id="myTabContent">
//           <div className={`p-4 ${activeTab === 'all' ? 'block' : 'hidden'}`} id="all" role="tabpanel" aria-labelledby="all-tab">
//             <AllTab searchQuery={searchQuery} />
//           </div>
//           <div className={`p-4 ${activeTab === 'admin' ? 'block' : 'hidden'}`} id="admin" role="tabpanel" aria-labelledby="admin-tab">
//             <AdminTab />
//           </div>
//           <div className={`p-4 ${activeTab === 'analyst' ? 'block' : 'hidden'}`} id="analyst" role="tabpanel" aria-labelledby="analyst-tab">
//             <AnalystTab />
//           </div>
//         </div>

//         {/* Pagination */}
//         <Pagination
//           totalPages={totalPages}
//           activePage={activePage}
//           onPageChange={handlePageChange}
//         />
//       </div>
//     </div>
//   );
// }

// export default Teams;





